import { render, staticRenderFns } from "./OrdenCompraDesdeProductosCreate.vue?vue&type=template&id=78bea55c&scoped=true&"
import script from "./OrdenCompraDesdeProductosCreate.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraDesdeProductosCreate.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompraDesdeProductosCreate.vue?vue&type=style&index=0&id=78bea55c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bea55c",
  null
  
)

export default component.exports